/**
 * Liga a landing do Oil of Oregano ao carrinho nativo da Be Neo.
 *
 * ESCRITO À MÃO — não sai de scripts/build-landing.py.
 *
 * oo-main.js (do clone) não toca no carrinho: ao clicar em CHOOSE MY PACKAGE ele
 * dispara o evento cancelável `be-neo:purchase`. Aqui cancelamos — o que também
 * suprime o toast de placeholder do clone — e montamos o carrinho.
 *
 * O Shipping protection ($3.95) entra junto com o bundle e vai para o checkout,
 * onde o Shopify não oferece remover linha. Ele NÃO é inviolável: /cart/change.js
 * é público, então quem abrir /cart de propósito consegue tirar. Travar de
 * verdade exigiria uma Cart Transform Function, que é um app. Ver pendencias.md.
 *
 * Escopo: este arquivo só é carregado por layout/oregano.liquid, então o
 * seguro só é somado nesta landing. Comprar oregano pela PDP normal da loja NÃO
 * adiciona o SP.
 */
(function () {
  'use strict';

  var FALLBACK = '45760590348423'; // 1 stand-up pouch
  var SHIPPING_PROTECTION = '45760673677447'; // SP · $3.95

  function selectedInput() {
    return document.querySelector('input[name="be-offer"]:checked');
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function showError(message) {
    var wrapper = document.querySelector('.product-form__error-message-wrapper');
    var target = document.querySelector('.product-form__error-message');
    if (!wrapper || !target) {
      window.alert(message);
      return;
    }
    target.textContent = message;
    wrapper.hidden = false;
  }

  function clearError() {
    var wrapper = document.querySelector('.product-form__error-message-wrapper');
    if (wrapper) wrapper.hidden = true;
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function postJSON(path, body) {
    return fetch(cartRoot() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Cart error');
        }
        return data;
      });
    });
  }

  var ultimoBotao = null;

  document.addEventListener('be-neo:purchase', function (event) {
    event.preventDefault();

    // Compra ainda em curso (toque duplo): a primeira já cuida de tudo.
    var cs = window.carrinhoSubstitui;
    if (cs && cs.ocupado()) return;

    clearError();

    var input = selectedInput();
    var variantId = (input && input.dataset.variantId) || FALLBACK;
    var button = event.target;
    ultimoBotao = button;

    setBusy(button, true);

    function passo() {
      return postJSON('cart/add.js', {
        items: [
          { id: Number(variantId), quantity: 1 },
          { id: Number(SHIPPING_PROTECTION), quantity: 1 }
        ]
      })
        // add.js SOMA à quantidade existente. Se o cliente já tinha o seguro no
        // carrinho, ficariam dois. change.js define a quantidade absoluta, então
        // esta segunda chamada garante exatamente um, quantas vezes o botão for
        // clicado. (Com o carrinho-substitui o carrinho já chega vazio; isto
        // segue valendo para quando ele não carregar.)
        .then(function () {
          return postJSON('cart/change.js', {
            id: SHIPPING_PROTECTION,
            quantity: 1
          });
        });
    }

    // Comprar SUBSTITUI o carrinho (assets/carrinho-substitui.js, 15/09/2026):
    // esvazia antes de adicionar, então o checkout recebe só esta escolha, e
    // não o bundle da visita anterior somado. Sem aquele arquivo, compra como antes.
    // O que o carrinho tem de conter no fim — o carrinho-substitui confere e
    // corrige antes do checkout: o bundle escolhido e um seguro.
    var esperado = [
      { id: Number(variantId), quantity: 1 },
      { id: Number(SHIPPING_PROTECTION), quantity: 1 }
    ];
    (cs ? cs.substituir(passo, esperado) : passo())
      .then(function () {
        // Direto para o checkout, sem passar por /cart — é lá que o cliente
        // teria botão de remover.
        window.location.href = cartRoot() + 'checkout';
      })
      .catch(function (error) {
        setBusy(button, false);
        showError(error.message || 'We could not add this to your cart. Please try again.');
      });
  });

  // Voltou do checkout pelo "voltar" (página restaurada do bfcache): o botão
  // ficou desabilitado por setBusy. Sem isto ele pareceria quebrado.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) setBusy(ultimoBotao, false);
  });
})();
